// extracted by mini-css-extract-plugin
export default {"block":"NotFoundPage_block__R5Vqj","error":"NotFoundPage_error__urK1N","text":"NotFoundPage_text__rMjX3"};